<template>
  <div class="group">
    <el-card>
      <el-form :inline="true" :model="filter" class="demo-form-inline" size="small">
        <el-form-item label="分组名称">
          <el-input v-model="filter.classifyName" placeholder="请输入分组名称"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" style="margin-left: 20px" @click="search">查询</el-button>
        </el-form-item>

        <el-button style="float: right;" type="primary" size="small" @click="dialogVisible = true">新建分组</el-button>
      </el-form>
    </el-card>

    <el-card style="margin-top: 10px;">
      <el-table :data="list" border>
        <el-table-column align="center" label="序号" type="index" width=""></el-table-column>
        <el-table-column align="center" label="分组名称" prop="classifyName" width=""></el-table-column>
        <el-table-column align="center" label="创建时间" prop="insertDate" width="200"></el-table-column>
        <el-table-column align="center" label="操作" prop="" width="200">
          <template slot-scope="scope">
            <a href="javascript:;" @click="$router.push({ path: '/certificate/detail', query: { id: scope.row.id, type: type } })">{{type === 1 ? '合格' : '结业'}}证书管理</a> &nbsp;
            <a href="javascript:;" @click="edit(scope.row)">编辑</a> &nbsp;
            <a href="javascript:;" @click="del(scope.row)">删除</a> &nbsp;
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px; text-align: center;"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose">
      分组名称: <el-input style="width: 300px" v-model="classifyName" maxlength="50" size="small" placeholder="请输入分组名称"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button size="small" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getListPage, addOutsideClassify, updateOutsideClassify, delOutsideClassify } from '@/api/certificate'
export default {
  data () {
    return {
      filter: {
        page: 1,
        limit: 10,
        classifyName: ''
      },
      type: 1,
      list: [],
      total: 0,
      dialogVisible: false,
      title: '新建分组',
      classifyName: '',
      row: null
    }
  },
  created() {
    if (this.$route.name === 'jyGroup') this.type = 2
    this.getList()
  },
  methods: {
    async getList() {
      let res = await getListPage({...this.filter, type: this.type})
      if (res.code !== 0) return this.$message.error(res.message)
      this.list = res.data.records
      this.total = +res.data.total
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset() {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = ''
      })
      this.filter.page = 1
      this.filter.limit = 10
      this.getList()
    },
    async submit() {
      if (!this.classifyName.trim().length) return this.$message.error('请输入')
      let res
      if (this.row) {
        res = await updateOutsideClassify({ classifyName: this.classifyName, type: this.type, id: this.row.id })
      } else {
        res = await addOutsideClassify({ classifyName: this.classifyName, type: this.type })
      }
      if (res.code !== 0) return this.$message.error(res.message)
      this.$message.success('操作成功')
      this.handleClose()
      this.getList()
    },
    del(row) {
      this.$confirm('您确定要删除该分组吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const res = await delOutsideClassify({ id: row.id })
        if (res.code !== 0) {
          this.$message.error(res.message)
          this.getList()
          return
        }
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        this.getList()
      }).catch(() => {});
    },
    edit(row) {
      this.row = row
      this.classifyName = row.classifyName
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.title = '新建分组'
      this.classifyName = ''
      this.row = null
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    },
  }
}
</script>

<style lang="scss" scoped>
.group {
  
}
</style>
